export const GENRES = [
  'Jazz',
  'Rock',
  'Pop',
  'Electronic',
  'Soul',
  'Funk',
  'Indie',
  'Hip-Hop',
  'R&B',
  'Classical',
  'Latin',
];

export const EVENTS = [
  'Corporate',
  'Festival',
  'Clubs',
  'Theatre',
  'Weddings',
  'Touring',
];
